import React from "react";
import { observer } from "mobx-react";
import { Table } from "@mantine/core";
import { Cubby } from "../../stores/Cubby";
import {
  IconBoltFilled,
  IconCheck,
  IconWallet,
  IconStack,
  IconShield,
} from "@tabler/icons-react";
import ShowBalanceRowSmall from "./showBalanceRowSmall";
import ShowBlockTimeRow from "./showBlocktimeRow";
import ShowConfirmationsRow from "./showConfirmationsRow";

const ChannelKeyData = observer(
  ({ channel, cubby }: { channel: any; cubby: Cubby }) => {
    const {
      confirmation_count,
      local_balance,
      remote_balance,
      capacity,
      local_reserve,
      remote_reserve,
      channel_opening_transaction_data,
    } = channel;

    // Safely access blocktime and confirmations from nested data
    const blocktime = channel_opening_transaction_data?.blocktime || null;
    const confirmations =
      channel_opening_transaction_data?.confirmations || confirmation_count;

    return (
      <Table>
        <tbody>
          {blocktime && (
            <ShowBlockTimeRow
              icon={IconBoltFilled}
              label="Opened"
              blocktime={blocktime}
              infoLink="https://docs.megalithic.me"
            />
          )}
          {confirmation_count && confirmation_count > 0 && (
            <ShowConfirmationsRow
              icon={IconCheck}
              label="Confirmations"
              confirmations={confirmation_count}
              infoLink="https://docs.megalithic.me"
            />
          )}
          {local_balance !== undefined && (
            <ShowBalanceRowSmall
              icon={IconWallet}
              label="Local Balance"
              amount={local_balance > 0 ? local_balance : null}
              cubby={cubby}
            />
          )}
          {remote_balance !== undefined && (
            <ShowBalanceRowSmall
              icon={IconWallet}
              label="Remote Balance"
              amount={remote_balance > 0 ? remote_balance : null}
              cubby={cubby}
            />
          )}
          {capacity !== undefined && (
            <ShowBalanceRowSmall
              icon={IconStack}
              label="Capacity"
              amount={capacity > 0 ? capacity : null}
              cubby={cubby}
            />
          )}
          {local_reserve !== undefined && (
            <ShowBalanceRowSmall
              icon={IconShield}
              label="Local Reserve"
              amount={local_reserve > 0 ? local_reserve : null}
              cubby={cubby}
            />
          )}
          {remote_reserve !== undefined && (
            <ShowBalanceRowSmall
              icon={IconShield}
              label="Remote Reserve"
              amount={remote_reserve > 0 ? remote_reserve : null}
              cubby={cubby}
            />
          )}
        </tbody>
      </Table>
    );
  }
);

export default ChannelKeyData;
